import { NgModule } from '@angular/core';
import { NgClass } from '@angular/common';

import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDropdownConfig, BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { LanguageService } from './services/language.service';
import { LanguageSwitchButtonComponent } from './components/language-switch-button/language-switch-button.component';
import { LanguageSwitchModalComponent } from './components/language-switch-modal/language-switch-modal.component';


@NgModule({
    imports: [
        NgClass,
        
        ModalModule.forRoot(),
        BsDropdownModule.forRoot(),
    ],
    exports: [
        LanguageSwitchButtonComponent
    ],
    declarations: [
        LanguageSwitchButtonComponent,
        LanguageSwitchModalComponent
    ],
    providers: [
        LanguageService,
        BsDropdownConfig
    ],
})
export class LanguageSwitchButtonModule { }
